"use strict";
/*
 * 8x8 Confidential & Proprietary || Copyright 2025 8x8, Inc. or its affiliates. All Rights Reserved.
 *  _____      _____
 * |  _  |    |  _  |
 *  \ V /__  __\ V /   ___ ___  _ __ ___
 *  / _ \\ \/ // _ \  / __/ _ \| '_ ` _ \
 * | |_| |>  <| |_| || (_| (_) | | | | | |
 * \_____/_/\_\_____(_)___\___/|_| |_| |_|
 *
 * @License https://www.8x8.com/terms-and-conditions/software-development-kit-license-agreement
 * @Author Comanici Paul
 * @Date 2025/08/28
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_CODES = void 0;
// the CODE_PREFIX is duplicated, however, I do not want to have a getter function for the codes,
//  so I can use the import
const CODE_PREFIX = "PUI_PARTNER";
const FILE_CODES = {
    // General file operations
    FILE_SEND_START: `${CODE_PREFIX}_FILE_SEND_START`,
    FILE_VALIDATION_WARNINGS: `${CODE_PREFIX}_FILE_VALIDATION_WARNINGS`,
    FILE_TRANSFER_CANCELLED: `${CODE_PREFIX}_FILE_TRANSFER_CANCELLED`,
    FILE_CANCEL_ERROR: `${CODE_PREFIX}_FILE_CANCEL_ERROR`,
    FILE_TRANSFER_COMPLETED: `${CODE_PREFIX}_FILE_TRANSFER_COMPLETED`,
    FILESENDER_SENDMESSAGE_NOT_AVAILABLE: `${CODE_PREFIX}_FILESENDER_SENDMESSAGE_NOT_AVAILABLE`,
    FILESENDER_NOT_AVAILABLE: `${CODE_PREFIX}_FILESENDER_NOT_AVAILABLE`,
    TRANSFER_NOT_FOUND: `${CODE_PREFIX}_TRANSFER_NOT_FOUND`,
    CHUNK_INTEGRITY_FAILED: `${CODE_PREFIX}_CHUNK_INTEGRITY_FAILED`,
    CHUNK_TRANSFER_FAILED: `${CODE_PREFIX}_CHUNK_TRANSFER_FAILED`,
    FILE_SEND_FAILED: `${CODE_PREFIX}_FILE_SEND_FAILED`,
    // File transformation codes
    FILE_TRANSFORM_START: `${CODE_PREFIX}_FILE_TRANSFORM_START`,
    FILE_HASH_GENERATION_ERROR: `${CODE_PREFIX}_FILE_HASH_GENERATION_ERROR`,
    FILE_TRANSFORM_COMPLETE: `${CODE_PREFIX}_FILE_TRANSFORM_COMPLETE`,
    FILE_TRANSFORM_ERROR: `${CODE_PREFIX}_FILE_TRANSFORM_ERROR`,
    CHUNK_SEQUENCE_ERROR: `${CODE_PREFIX}_CHUNK_SEQUENCE_ERROR`,
    CHUNK_SIZE_MISMATCH: `${CODE_PREFIX}_CHUNK_SIZE_MISMATCH`,
    CHUNK_FILE_ID_MISMATCH: `${CODE_PREFIX}_CHUNK_FILE_ID_MISMATCH`,
    CHUNK_VALIDATION_ERROR: `${CODE_PREFIX}_CHUNK_VALIDATION_ERROR`,
    // File validation codes
    FILE_VALIDATION_PASSED: `${CODE_PREFIX}_FILE_VALIDATION_PASSED`,
    FILE_VALIDATION_FAILED: `${CODE_PREFIX}_FILE_VALIDATION_FAILED`,
    FILE_VALIDATION_ERROR: `${CODE_PREFIX}_FILE_VALIDATION_ERROR`,
    // Crypto codes
    CRYPTO_NOT_AVAILABLE: `${CODE_PREFIX}_CRYPTO_NOT_AVAILABLE`,
    CRYPTO_KEY_GENERATED: `${CODE_PREFIX}_CRYPTO_KEY_GENERATED`,
    CRYPTO_KEY_GENERATION_ERROR: `${CODE_PREFIX}_CRYPTO_KEY_GENERATION_ERROR`,
    CRYPTO_KEY_IMPORTED: `${CODE_PREFIX}_CRYPTO_KEY_IMPORTED`,
    CRYPTO_KEY_IMPORT_ERROR: `${CODE_PREFIX}_CRYPTO_KEY_IMPORT_ERROR`,
    CRYPTO_ENCRYPT_SUCCESS: `${CODE_PREFIX}_CRYPTO_ENCRYPT_SUCCESS`,
    CRYPTO_ENCRYPT_ERROR: `${CODE_PREFIX}_CRYPTO_ENCRYPT_ERROR`,
    CRYPTO_DECRYPT_SUCCESS: `${CODE_PREFIX}_CRYPTO_DECRYPT_SUCCESS`,
    CRYPTO_DECRYPT_ERROR: `${CODE_PREFIX}_CRYPTO_DECRYPT_ERROR`,
    // File receiver codes
    FILE_RECEIVE_START: `${CODE_PREFIX}_FILE_RECEIVE_START`,
    FILE_RECEIVE_CHUNK: `${CODE_PREFIX}_FILE_RECEIVE_CHUNK`,
    FILE_RECEIVE_COMPLETE: `${CODE_PREFIX}_FILE_RECEIVE_COMPLETE`,
    FILE_RECEIVE_ERROR: `${CODE_PREFIX}_FILE_RECEIVE_ERROR`,
    FILE_RECONSTRUCTION_SUCCESS: `${CODE_PREFIX}_FILE_RECONSTRUCTION_SUCCESS`,
    FILE_RECONSTRUCTION_ERROR: `${CODE_PREFIX}_FILE_RECONSTRUCTION_ERROR`,
    RECEIVER_TRANSFER_NOT_FOUND: `${CODE_PREFIX}_RECEIVER_TRANSFER_NOT_FOUND`,
    RECEIVER_CHUNK_DECRYPT_ERROR: `${CODE_PREFIX}_RECEIVER_CHUNK_DECRYPT_ERROR`,
};
exports.FILE_CODES = FILE_CODES;
//# sourceMappingURL=observability.codes.js.map